import { Table as RoudingTable } from 'components/table/rouding_rules/Table'
import React from 'react'

const RoundingRules = () => {
    return (
        <>
            <RoudingTable />
        </>
    )
}

export { RoundingRules }